import React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AuthLayout from '../Components/AuthLayout';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { forgotPassword } from '../redux/actions/authActions';

function ForgotPassword() {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const dispatch = useDispatch();
  const { forgotPasswordLoading, forgotPasswordError } = useSelector(state => state.auth);
  
  const onSubmit = async (data) => {
    try {
      await dispatch(forgotPassword(data.email));
      // Clear form after successful submission
      reset();
    } catch (error) {
      // Error is already handled in the action creator
      console.error('Forgot password error:', error);
    }
  };
  // const inputStyle = {
  //   background: '#fff',
  //   borderRadius: 4,
  //   fontSize: 15,
  //   color: '#111',
  // };
  return (
    <AuthLayout>
      <h2 style={{ fontWeight: 800, marginBottom: 22, textAlign: 'left', fontFamily: 'Inter, sans-serif', color: '#e2e8f0' }}>Forgot password</h2>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div style={{ marginBottom: 20 }}>
            <TextField
              label="Email"
              type="email"
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ style: { background: 'transparent', color: '#e2e8f0' } }}
              {...register('email', { required: 'Email is required' })}
              error={!!errors.email}
              helperText={errors.email ? errors.email.message : ''}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
            />
          </div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={forgotPasswordLoading}
            sx={{ background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 16, mb: 1, borderRadius: 2, py: 1, '&:hover': { background: '#1e40af' }, '&:disabled': { background: '#64748b' } }}
          >
            {forgotPasswordLoading ? 'Sending...' : 'Send Reset Link'}
          </Button>
      </form>
      <div style={{ textAlign: 'center', marginTop: 12 }}>
        <Link to="/login" style={{ color: '#94a3b8', fontWeight: 500, textDecoration: 'none' }}>Back to Login</Link>
      </div>
    </AuthLayout>
  );
}

export default ForgotPassword;
